// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__XFNHu","social":"Footer_social__sTJvj","svg":"Footer_svg__xsj5A","copyright":"Footer_copyright__XXvQ+"};